export const menu = [
  { title: 'Home', path: '/' },
  { title: 'Insights & News', path: '/spotlight' },
  { title: 'Core Services', path: '/services' },
  { title: 'Publications', path: '/publications' },
  { title: 'About Us', path: '/team' },
];